<div ngForm="form">
	@if (value) {
		<div class="margin-bottom-20" layout="row" flex-align="center" flex-justify="center" flex-wrap="false">
			<div flex>
				@if (showToggleBtn) {
					<vb-toggle-button name="enableEmbeddedToggle" [ariaLabel]="'Event_Embed_Content_Toggle' | translate" [(ngModel)]="value.isEnabled" (ngModelChange)="onEnabledToggleClick()">
					</vb-toggle-button>
				} @else {
					<span [ngClass]="[styles.entryIcon, 'vb-icon vb-icon-center vb-icon-' + value.icon]"></span>
				}
			</div>

			<div [ngClass]="styles.entryNameContainer" flex="50">
				<span [ngClass]="styles.entryName">{{ value.name }}</span>
			</div>

			<div [ngClass]="styles.actions" flex="20">
				@if (showEditDeleteBtns) {
					<button class="btn btn-transparent" type="button" (click)="onEditClick()">{{ 'Edit' | translate }}</button>
					<button class="btn btn-transparent" type="button" (click)="onDeleteClick()">{{ 'Delete' | translate }}</button>
				}
				@if (showPreviewBtn && value.resourceUri) {
					<button class="btn btn-transparent" type="button" (click)="onPreviewClick()">{{ 'Preview' | translate }}</button>
				}
			</div>
		</div>
	}
</div>
